module.exports = __webpack_public_path__ + "static/img/1_1_5_1.7ddef64b.jpg";